module.exports = "https://and-static.ghzs.com/web/bbs-desktop/static/img/bg_bangdan.3dbf7.png";